//import { SocialFeedEntry } from './SocialFeedEntry';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useEffect, useRef } from 'react';
import { useWindowSize } from '../../hooks/useWindowSize';
import { Timeline } from 'react-twitter-widgets';
import { SocialFeedError } from './SocialFeedError';
import { ImageOptimized } from '../image/ImageOptimized';

type SocialFeedProps = {
  handleToggle: () => void;
  socialFeedOpen: boolean;
  competitionBoardRef: React.RefObject<HTMLDivElement>;
};

export function SocialFeed({
  handleToggle,
  socialFeedOpen,
  competitionBoardRef,
}: SocialFeedProps) {
  const theme = useTheme();
  const socialFeedRef = useRef();
  const windowSize = useWindowSize();

  // TODO: Refactor to CSS-based solutions
  const updateSocialFeedHeight = () => {
    if (competitionBoardRef?.current && socialFeedRef?.current) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const socialFeedRefCurrent = socialFeedRef.current as any;
      const competitionBoardRect =
        competitionBoardRef.current.getBoundingClientRect();
      const socialFeedRect = socialFeedRefCurrent.getBoundingClientRect();
      const height = competitionBoardRect.bottom - socialFeedRect.top;
      socialFeedRefCurrent.style.height = `${height}px`;
    }
  };
  useEffect(updateSocialFeedHeight, [
    competitionBoardRef,
    //competitionBoardRef.current,
    socialFeedRef,
    //socialFeedRef.current,
    windowSize,
  ]);
  updateSocialFeedHeight();
  setTimeout(updateSocialFeedHeight, 1000);
  setTimeout(updateSocialFeedHeight, 2000);
  setTimeout(updateSocialFeedHeight, 3000);

  //const [socialEntries, setSocialEntries] = useState<Chatter[]>([]);
  // const chatterQuery = useMoralisQuery('Chatter', (query) =>
  //   query.equalTo('category', 'social media').descending('updatedAt'),
  // );
  // useEffect(() => {
  //   if (chatterQuery.data && chatterQuery.data.length > 0) {
  //     setSocialEntries(chatterQuery.data as Chatter[]);
  //   }
  // }, [chatterQuery.data]);
  //TODO: change to modal view on small screens
  //TODO: add animations for opening and closing the social feed
  //TODO: figure out how to fetch the real data

  return socialFeedOpen ? (
    <Box
      ref={socialFeedRef}
      sx={{
        position: 'relative',
        minWidth: '450px',
        width: '450px',
        height: '100%',
        overflow: 'hidden',
        background: theme.palette.background.elevation['12'],
        backdropFilter: 'blur(25px)',
        borderRadius: '10px',
        borderLeft: 'none',
        '& h6': {
          marginLeft: '16px',
        },
      }}
    >
      {/* <Box sx={{ pt: 2, pb: 2 }}>
        <GradientTypography
          variant="h5"
          gradientColor="primary.vertical"
          sx={{
            textTransform: 'uppercase',
            pl: 4,
          }}
        >
          Social Feed
        </GradientTypography>
      </Box> */}
      <Box
        sx={{
          overflowY: 'auto',
          height: '100%',
        }}
      >
        <Timeline
          dataSource={{ sourceType: 'profile', screenName: 'blumint_' }}
          renderError={(error) => <SocialFeedError error={error} />}
          options={{
            theme: 'dark',
            tweetLimit: 20,
            width: '450',
            chrome: 'noheader, transparent, noscrollbar',
          }}
        />
      </Box>
      {/* <Box
        sx={{
          width: '480px',
          paddingLeft: '16px',
          paddingRight: '16px',
          borderRadius: '5px',
          maxHeight: '95%',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'block',
          ...theme.palette.scrollbars.primary,
        }}
      >
        {socialEntries.map((entry) => (
          <SocialFeedEntry
            type={entry.attributes.socialMediaType as string}
            key={entry.id}
            post={{
              author: {
                name: entry.attributes.author,
                imgUrl: entry.attributes.authorImgUrl,
              },
              text: entry.attributes.description,
              engagement: entry.attributes.engagement,
              server: entry.attributes.server,
              videoUrl: entry.attributes.videoUrl,
              imgUrl: entry.attributes.imgUrl,
            }}
          />
        ))}
      </Box> */}
    </Box>
  ) : (
    <Box
      sx={{
        width: '56px',
        background: theme.palette.background.elevation['10'],
        backdropFilter: 'blur(25px)',
        paddingLeft: '18px',
        paddingTop: '19px',
        backgroundClip: 'padding-box',
        WebkitMaskRepeat: 'no-repeat',
        border: '2px solid #279BF6',
        borderRadius: '0px 10px 10px 0px',
        borderLeft: 'none',
        boxShadow: theme.shadows[4],
        '&:hover': {
          boxShadow: theme.shadows[7],
        },
      }}
    >
      <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
        <ImageOptimized
          onClick={handleToggle}
          src={'/assets/icons/right-arrow-gradient.svg'}
          width={20}
          height={20}
          alt={'Open social feed'}
        />
      </Box>
    </Box>
  );
}
